import React from 'react'

import type { RegionElementState } from 'EditorApp/types'
import RenderedSvgElement from 'components/RenderedSvgElement'
import { styleForColorOrGradient } from 'utils/colorHelpers'

interface Props {
  element: RegionElementState
}

const RegionElement = ({ element }: Props) => {
  if (element.renderedSvg) {
    return (
      <RenderedSvgElement
        name="RegionElement"
        id={element.id}
        svg={element.renderedSvg}
      />
    )
  }

  const {
    width,
    height,
    backgroundColor,
    outlineColor,
    outlineWidth,
    borderRadius,
  } = element

  const border =
    outlineColor !== 'transparent'
      ? `${outlineWidth}px solid ${outlineColor}`
      : 'none'

  return (
    <div
      className="RegionElement"
      style={{
        width,
        height,
        borderRadius,
        ...styleForColorOrGradient(backgroundColor),
        border,
      }}
      data-element-id={element.id}
    />
  )
}

export default RegionElement
